import React, { memo, useCallback } from 'react';

import { Grid, Layout } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import type { IOrganization } from '@src/@types/microcredits';
import { Logo } from '@src/components/Logotype';
import { TOP_PAGE_ANCHOR } from '@src/constants/common';
import { scrollToElementById } from '@src/helpers/common';
import { getOrganizationPageLink } from '@src/helpers/links';

import { ActionButton } from '../ActionButton';
import { ArrowButton } from '../ArrowButton';

import styles from './styles.module.scss';

interface IProps {
  name: string;
  organization: IOrganization;
  isSticky: boolean;
  style?: {
    transform?: string;
  };
  isPartner?: boolean;
}

export const StickyBlock: React.FunctionComponent<IProps> = memo(
  ({ name, organization, isSticky, style, isPartner }) => {
    const isMobile = useIsMobile();
    const logoLink = { href: getOrganizationPageLink(organization.alias), withAdvertising: false };

    const handleClickOnScrollTop = useCallback(() => {
      scrollToElementById(TOP_PAGE_ANCHOR, { offset: isMobile ? -50 : -60 });
    }, [isMobile]);

    if (isMobile || !organization) return null;

    return (
      <div className={styles.wrapper} data-active={isSticky ? true : undefined} style={style}>
        <div className={styles.container}>
          <Layout className={styles.layout}>
            <Grid.Row className={styles.row} align="middle" justify="space-between">
              <Grid.Col span={9}>
                <Grid.Row gutter={20} justify="space-between" align="middle">
                  <Grid.Col className={styles.col} span={10}>
                    <Logo link={logoLink} logo={organization.logotypes?.android} isPartner={isPartner} />
                    <div className={styles.title}>{name}</div>
                  </Grid.Col>
                  <Grid.Col>
                    <ArrowButton text="Наверх" onClick={handleClickOnScrollTop} />
                  </Grid.Col>
                </Grid.Row>
              </Grid.Col>
              <Grid.Col className={styles.button_col} span={3}>
                <ActionButton />
              </Grid.Col>
            </Grid.Row>
          </Layout>
        </div>
      </div>
    );
  },
);
